'use client';

import React from 'react';

export const AnimatedGradientBg: React.FC = () => {
  return (
    <div className="absolute inset-0 overflow-hidden -z-10">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[var(--bg-gradient-from)] to-[var(--bg-gradient-to)] animate-gradient-shift" />

      {/* Floating gradient orbs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-[var(--orb-c1)] to-transparent rounded-full blur-3xl animate-float-slow" />
      <div className="absolute top-1/4 right-0 w-80 h-80 bg-gradient-to-br from-[var(--orb-c2)] to-transparent rounded-full blur-3xl animate-float-slower" />
      <div className="absolute bottom-0 left-1/3 w-72 h-72 bg-gradient-to-br from-[var(--orb-c3)] to-transparent rounded-full blur-3xl animate-float-medium" />
      <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-gradient-to-br from-[var(--orb-c4)] to-transparent rounded-full blur-3xl animate-float-fast" />

      {/* Subtle overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-t from-white/10 to-transparent" />
    </div>
  );
};
